import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CustomNavbar from '../../components/CustomNavbar';
import SidebarConfig from '../../components/SidebarConfig';
import { useDispatch, useSelector } from "react-redux";


const Settings = () => {
  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  const userRoles = useSelector((store) => store.auth.userRoles);

  return (
    <>
      <CustomNavbar onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="jumbotron">
            <h1 className="font-weight-bold">Configuración de Aurora</h1>
            <hr className="my-4" />
            <p className="mb-4">Desde aquí podrás administrar todas las configuraciones de la aplicación,
              a continuación te mostramos algunos accesos rápidos para que puedas comenzar</p>
            <Row>
              <Col>
                <h4 className="mb-3">Administrar usuarios</h4>
                <Link className="btn btn-primary btn-lg" to="/usuarios" role="button">Usuarios</Link>
              </Col>
              <Col>
                <h4>Estructura Funcional</h4>
                <ul className="ml-3 p-0">
                  <li><Link to="/cargos/2">Puestos</Link></li>
                  <li><Link to="/unidad/2">Areas</Link></li>
                  <li><Link to="/plazas/2">Plazas</Link></li>
                  <li><Link to="/division-personal/2">Mant. división personal</Link></li>
                  <li><Link to="/institutos/2">Mant. institutos</Link></li>
                  <li><Link to="/situacion-actual/2">Mant. situación actual</Link></li>
                  <li><Link to="/especializacion/2">Mant. especialización</Link></li>
                  <li><Link to="/diagnosticos/2">Mant. diagnósticos</Link></li>
                  <li><Link to="/mantenimiento-vacunas/2">Mant. vacunas</Link></li>
                  <li><Link to="/mantenimiento-laboratorios/2">Mant. laboratorios</Link></li>
                  <li><Link to="/mantenimiento-documentacion/2">Mant. documentos</Link></li>
                  <li><Link to="/empresas-filtro-empleados/2">Mant. empleados</Link></li>
                  <li><Link to="/country-maintenance">Mant. Paises</Link></li>
                  <li><Link to="/department-maintenance">Mant. Departamentos</Link></li>
                  <li><Link to="/municipality-maintenance">Mant. Municipios</Link></li>
                  <li><Link to="/cost-center-maintenance">Mant. Centro de Costo</Link></li>
                  <li><Link to="/aurora-division/2">Mant. División Aurora</Link></li>
                  {userRoles.length > 0 &&
                    (userRoles.includes("Responsable_Rol_Empresa") || userRoles.includes("administrador")) ? (

                    <li><Link to="/usuario-empresa/2">Mant. Usuario Empresa</Link></li>
                  ) : null}
                </ul>
              </Col>
              <Col className="pt-4">
                <h4>Estructura Formal</h4>
                <ul className="ml-3 p-0">
                  {/*<li><Link to="/cargos-formal">Puestos</Link></li>
                  <li><Link to="/unidad-formal">Areas</Link></li>
                  <li><Link to="/plazas-formal">Plazas</Link></li>
                  <li><Link to="/division-personal-formal">Mant. división personal</Link></li>
                  <li><Link to="/institutos-formal">Mant. institutos</Link></li>
                  <li><Link to="/situacion-actual-formal">Mant. situación actual</Link></li>
                  <li><Link to="/especializacion-formal">Mant. especialización</Link></li>
                  <li><Link to="/diagnosticos-formal">Mant. diagnósticos</Link></li>
                  <li><Link to="/mantenimiento-vacunas/1">Mant. vacunas</Link></li>
                  <li><Link to="/mantenimiento-laboratorios/1">Mant. laboratorios</Link></li>
                  <li><Link to="/mantenimiento-documentacion/1">Mant. documentos</Link></li>*/}
                  <li><Link to="/empresas-filtro-empleados/1">Mant. empleados</Link></li>
                </ul>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

export default Settings
